import React from 'react'
import { Box } from '@mantine/core'
import { FiUpload } from 'react-icons/fi'
import AppButton from '../../app/common/ui/AppButton'
import AppText from '../../app/common/ui/AppText'

type HeaderVariant = 'discover' | 'library' | 'embed'

interface SlopFeedPageHeaderProps {
  variant: HeaderVariant
  onUploadClick?: () => void
}

const COPY: Record<HeaderVariant, { subtitle: string; compact?: boolean }> = {
  discover: {
    subtitle: 'Shoots, slop videos, and blog posts in one scroll. Long-form uploads live in the video library.',
    compact: true
  },
  library: {
    subtitle: 'Long-form slop uploads with titles, linking, and comments.'
  },
  embed: {
    subtitle: 'Add an embedded video (YouTube, etc.) to the library. Admin only.',
    compact: true
  }
}

export default function SlopFeedPageHeader ({ variant, onUploadClick }: SlopFeedPageHeaderProps) {
  const { subtitle, compact } = COPY[variant]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: compact ? 100 : 160,
        gap: compact ? 10 : 16,
        textAlign: 'center',
        marginBottom: compact ? 12 : 24,
        '@media (max-width: 575px)': {
          minHeight: compact ? 72 : 120,
          marginBottom: compact ? 8 : 16
        }
      }}
    >
      <AppText
        sx={{
          fontFamily: 'Oswald, sans-serif',
          fontWeight: 700,
          fontSize: compact ? 36 : 48,
          letterSpacing: 4,
          color: 'var(--gs-accent)',
          lineHeight: 1,
          '@media (max-width: 575px)': { fontSize: compact ? 28 : 32 }
        }}
      >
        {variant === 'library' ? 'VIDEO LIBRARY' : 'SLOP FEED'}
      </AppText>
      <AppText
        sx={{
          fontFamily: 'DM Sans, sans-serif',
          fontSize: compact ? 15 : 18,
          color: 'var(--gs-muted)',
          maxWidth: 560,
          '@media (max-width: 575px)': { fontSize: 14, px: 4 }
        }}
      >
        {subtitle}
      </AppText>
      {variant === 'library' && onUploadClick && (
        <AppButton
          onClick={onUploadClick}
          sx={{
            marginTop: 8,
            background: 'rgba(232,93,4,0.15)',
            border: '1px solid rgba(232,93,4,0.35)',
            color: 'var(--gs-accent)',
            '&:hover': { background: 'rgba(232,93,4,0.25)' }
          }}
          leftIcon={<FiUpload size={16} />}
        >
          Upload Video
        </AppButton>
      )}
    </Box>
  )
}
